import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Selectors
import {
    makeSelectTimesheetEntryApiErrorExists
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesAPIErrors/selectors';
import {
    makeSelectFormErrorExists
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesForm/selectors';
import {
    makeSelectIsRowSelected
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

export interface OwnProps {
    rowId: string | number;
    timesheetEntryUuid: string | number;
    children: React.ReactNode;
}

interface StateProps {
    apiErrorExists?: boolean;
    formErrorExists?: boolean;
    isRowSelected: boolean;
}

type IProps = StateProps & OwnProps;

export class TimesheetEntriesTableRowWrapper extends React.PureComponent<
    IProps
> {
    render(): React.ReactElement {
        const {
            timesheetEntryUuid,
            children,
            apiErrorExists,
            formErrorExists,
            isRowSelected
        } = this.props;

        let style = {};
        if (isRowSelected) {
            style = {
                background: '#eef5ff'
            };
        }

        if (apiErrorExists || formErrorExists) {
            style = {
                background: '#fff6f6'
            };
        }

        return (
            <Table.Row id={timesheetEntryUuid} style={style}>
                {children}
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    apiErrorExists: makeSelectTimesheetEntryApiErrorExists(),
    formErrorExists: makeSelectFormErrorExists(),
    isRowSelected: makeSelectIsRowSelected()
});

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(
    TimesheetEntriesTableRowWrapper
);
